import { Routes, Route } from '@angular/router';
import { ShellComponent } from './shell.component';
import { WaitForCompanyLoadGuard } from '@app/core/guards/wait-for-company-load.guard';

/**
 * Provides helper methods to create routes.
 */
export class Shell {
  static childRoutes(routes: Routes): Route {
    return {
      path: '',
      component: ShellComponent,
      children: routes,
      // Reuse ShellComponent instance when navigating between child views
      data: { reuse: false },
      canActivate: [WaitForCompanyLoadGuard],
    };
  }
}
